import React from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import Fade from 'react-reveal/Fade'
import parse from 'html-react-parser'

const ClientLogos = ({heading, logos, oneRow}) => {

  return (
    <section className={`client-logos${oneRow ? ' client-logos--one-row' : ''}`}>
      <Fade distance='40px' bottom>
        <div className="client-logos__inner">
        { heading && <h2>{parse(heading)}</h2> }
        <div className="client-logos__ticker">
          {
            logos[0].logosGallery.map((el, index) => (
              <GatsbyImage key={index} image={getImage(el.localFile)} alt={el.altText}/>
            ))
          }
          {
            logos[0].logosGallery.map((el, index) => (
              <GatsbyImage key={index} image={getImage(el.localFile)} alt={el.altText}/>
            ))
          }
        </div>

        { !oneRow && 
          <div className="client-logos__ticker">
            {
              logos[1]?.logosGallery.map((el, index) => (
                <GatsbyImage key={index} image={getImage(el.localFile)} alt={el.altText}/>
              ))
            }
            {
              logos[1]?.logosGallery.map((el, index) => (
                <GatsbyImage key={index} image={getImage(el.localFile)} alt={el.altText}/>
              ))
            }
          </div>
        }
        </div>
      </Fade>
    </section>
  );
};

export default ClientLogos